import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checklist-step__title" }

import { Mixpanel } from '@/analytics/mixpanel'

import type { ChecklistStepView } from '@/models/checklist'
import type { ChecklistDocs } from '@/models/checklist.types'

// We the only really required prop is `title`. We mark the
// rest as optional so that we can set the free initial step
// (eg. "Join Shortform").
interface PartialStep extends Partial<ChecklistStepView> {
  title: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChecklistStep',
  props: {
    step: {},
    docs: {},
    isNext: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

function onCtaClick(): void {
  if (!props.step.onClick || props.step.isCompleted) {
    return
  }

  const step = props.step as ChecklistStepView
  step.onClick(step, props.docs)
  Mixpanel.trackChecklistStepClicked(step.id!)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["checklist-step", {
      'checklist-step--completed': __props.step.isCompleted,
      'checklist-step--next': __props.isNext,
    }])
  }, [
    _createElementVNode("button", {
      class: "checklist-step__inner",
      onClick: onCtaClick
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "checklist-step__icon" }, null, -1)),
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.step.title), 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "checklist-step__chevron" }, [
        _createElementVNode("span", { class: "iconfont iarrow-down" })
      ], -1))
    ])
  ], 2))
}
}

})